<div class="container">
  <app-language-selector/>
  <span>|</span>
  <button style="background-color: green; color: white;"
    type="button"
    title="Fill current visible form with random values"
    (click)="testDataService.fillData()">
    Fill Data
  </button>
  <span>|</span>
  <select (change)="setTypeRentalPoints($event)" title="Chose how start/end rental points will be filled">
    <option [value]="true" [selected]="testDataService.sameRentalPoint">Same rental</option>
    <option [value]="false" [selected]="!testDataService.sameRentalPoint">Different rental</option>
  </select>
  <span>|</span>
  <select (change)="setCardType($event)" title="Chose card type to use">
    <option [value]="1" [selected]="cardNumber === cards.get(1)">Success card</option>
    <option [value]="2" [selected]="cardNumber === cards.get(2)">May 3DS card</option>
    <option [value]="3" [selected]="cardNumber === cards.get(3)">3DS card</option>
    <option [value]="0" [selected]="cardNumber === cards.get(0)">Error card</option>
  </select>
  <button style="background-color: yellow;"
    type="button"
    title="Copy chosen card's number in clipboard"
    (click)="copyCardClipboard()">
    Copy
  </button>
</div>
